






















import {Component, Prop, Vue} from "vue-property-decorator";
import ThemeVariableStore from "@/store/modules/ThemeVariableStore";

@Component({
    components: {
    }
})
export default class ImagePreviews extends Vue {
    @Prop() private imageUrls!: { [language_code: string]: string };

    get languages(): CMS.Language[] {
        if (!ThemeVariableStore.all.value)
            return [];

        return ThemeVariableStore.all.value.languages;
    }

    private getImageUrl(languageCode: string): string {
        if (!this.imageUrls)
            return "";

        if (!(languageCode in this.imageUrls))
            return "";

        return this.imageUrls[languageCode];
    }

}
